module.exports = __webpack_public_path__ + "static/media/grocery-product-5.b170e74a.png";